import type { CSSProperties } from "react";

/**
 * Break a block out of a centered max-width column so it spans the layout shell.
 *
 * Uses **`cqw`** against the nearest inline-size query container (layout shell —
 * {@link LayoutShellMeasure} in builder, {@link PublicLayoutContentShell} on region).
 */
function withoutHorizontalMarginShorthand(
	base: CSSProperties | undefined
): CSSProperties {
	if (!base) {
		return {};
	}
	const {
		margin: _margin,
		marginLeft: _marginLeft,
		marginRight: _marginRight,
		...rest
	} = base;
	return rest;
}

export function mergeFullBleedLayoutStyle(
	base: CSSProperties | undefined,
	active: boolean
): CSSProperties {
	if (!active) {
		return base ?? {};
	}

	const rest = withoutHorizontalMarginShorthand(base);

	return {
		...rest,
		width: "100cqw",
		maxWidth: "100cqw",
		marginLeft: "calc(50% - 50cqw)",
		marginRight: "calc(50% - 50cqw)",
		boxSizing: "border-box",
	};
}
